// Tracks the "this brand-new worker still has to pick who they work for" state
// across the post-registration navigation. Set when a QR-registered worker
// (subcontractor / employee) lands on the pick-employer step (the scanned
// jobsite handle is the picker's context); cleared once they file a join
// request. The presence of the handle IS the "needs to pick" signal the
// dashboard gate checks — so a teamless worker can't slip past it, and a worker
// who's already requested isn't re-prompted. Survives reloads (localStorage);
// independent of the pendingPath deep-link, which gets consumed separately.

const SITE_KEY = 'wesafe.onboardTeamSite';

// `handle` is the scanned jobsite handle (opaque publicId) from the deep-link.
export function setOnboardTeamSite(handle: string): void {
  try {
    localStorage.setItem(SITE_KEY, handle);
  } catch {
    // private mode / quota — the gate just won't fire; acceptable.
  }
}

export function peekOnboardTeamSite(): string | null {
  try {
    return localStorage.getItem(SITE_KEY);
  } catch {
    return null;
  }
}

export function clearOnboardTeamSite(): void {
  try {
    localStorage.removeItem(SITE_KEY);
  } catch {
    // ignore
  }
}

// Whether this person may check in on site before finishing onboarding
// (Brendon, 2026-09-29: subcontractors stood at the gate unable to sign on
// because the wizard wasn't done). An account whose company is settled is
// enough — their own company, or an employer they belong to or have asked to
// join. The server's access verdict still decides whether they get on.
export function canCheckInBeforeOnboarding(
  user: { role?: string; team?: { ownerUserId?: string | number | null } | null } | null | undefined
): boolean {
  if (!user?.role) return false;
  const isWorker = user.role === 'subcontractor' || user.role === 'employee';
  // Same "still owes a team pick" signal the dashboard gate reads.
  return !(isWorker && !user.team?.ownerUserId && peekOnboardTeamSite());
}
